import { Component, OnInit } from '@angular/core';
import { environment } from "@environments/environment";

// Services
import { ResourceService, UserService } from '@services/index.service';

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

//Constants
import { AppConstants } from '@app/appConstants';
import { DatabaseResourcesService } from '@services/database-resources/database-resources.service';
import { PortalConfigurationService } from '@services/portal-configuration/portal-configuration.service';

/** Footer de la aplicación que puede incluir un simple formulario para contactar con el propietario */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {

  NAME = environment.NAME;
  ADDRESS = environment.ADDRESS;
  PHONE = environment.PHONE;
  EMAIL = environment.EMAIL;
  APPINPLAYSTORE = environment.APPINPLAYSTORE;
  PLAYSTOREAPPURL = environment.PLAYSTOREAPPURL;
  stringPhone = "tel:" + environment.PHONE;
  environment = environment;

  contactForm = {
    contactFormMail: null,
    contactFormMessage: null,
  }

  alertOk: string;
  alertError: string;
  sending: string = 'SENDING';
  loading: boolean;


  constructor(public _resourceService: ResourceService, public _databaseResourcesService: DatabaseResourcesService,
    public _portalConfigurationService: PortalConfigurationService, public _userService: UserService) {
  }

  /** Valida un mail para saber si tiene un formato correcto */
  validateEmail(email) {
    var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
    if (pattern.test(email)) {
      return true;
    } else {
      return false;
    }
  }

  /**
  * Manda la string que saca del formulario de contacto al back para que lo envie y muestra un mensaje de alerta si
  * la respuesta del back es correcta
  */
  sendMail() {
    delete this.alertOk;
    delete this.alertError;
    this.loading = true;
    if (this.validateEmail(this.contactForm.contactFormMail)) {
      this._resourceService.sendMail(this.contactForm).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.alertOk = 'THANKS_FOR_CONTACTING';
          this.loading = false;
        } else {
          this.alertError = response.METADATA.ERROR_MESSAGE;
          this.loading = false;
        }
      });
    } else {
      this.alertError = 'PLEASE_REVIEW_YOUR_EMAIL';
      this.loading = false;
    }
  }

}
